import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchQualityTemplateMainReps({ packing_house_id, packing_house_process_id }) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/list_templates/${packing_house_id}/${packing_house_process_id}`
    );
  },
  fetchPackingHouseProcess({ packing_house_id, packing_house_process_id }) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/list_templates/${packing_house_id}/packing_house_process/${packing_house_process_id}`
    );
  }
};
